// Application configuration
//
// VITE_API_BASE — origin of the Virgy backend (the HR hub that owns the data).
// Production: e.g. https://hub.lamptwist.be  (ask the team for the exact origin).
// The API client appends `/api/jobs/...` to this base.
//
// Leave empty in local dev to use Vite's dev proxy (see vite.config.js), which
// forwards /api -> the Virgy origin so the browser stays same-origin (no CORS).
const config = {
  apiBase: (import.meta.env.VITE_API_BASE || '').replace(/\/$/, ''),
  // Target for the open / spontaneous application CTA (group-wide).
  spontaneousEmail: import.meta.env.VITE_SPONTANEOUS_EMAIL || 'info@lamptwist.be',
};

export default config;
